import { Sport } from './conference';
import { Game } from './game';
import { Team } from './team';

export interface QwikcutCamera {
	_id?: string;
	cameraId: string;
	label?: string;
	jetsonSerialNumber?: string;
	carrierBoardSerialNumber?: string;
	axisCameraSerialNumber?: string;
	poeSplitterSerialNumber?: string;
	poeInjectorSerialNumber?: string;
	ssdSerialNumber?: string;
	teamids?: Team['_id'][];
	socketId?: string;
	recordingGameid?: Game['_id'];
	previewPlaybackUrl?: string;
	currentSoftware?: QwikcutCameraSoftware[];
	roiConfig?: RoiConfig;
	jetsonMacAddress?: string;
	createdAt?: Date;
	updatedAt?: Date;

	//not in db
	teams?: Team[];
	currentRecordingData?: QwikcutCameraCurrentRecordingData;
	upcomingRecordings?: Game[];
	loadingUpcomingRecordings?: boolean;
}

export interface QwikcutCameraSoftware {
	_id?: string;
  name: string;
	type: QwikcutCameraSoftwareType;
	sportid?: Sport;
  version: number;
	createdAt?: Date;
	updatedAt?: Date;
}

export interface QwikcutCameraCurrentRecordingData {
	gameid?: string;
	remoteRtmpUrl?: string;
	endTime?: Date;
	game?: Game;
}


export enum QwikcutCameraSoftwareType {
  project = 'project',
  visionApp = 'visionApp',
  model = 'model',
  config = 'config',
  ngrok = 'ngrok'
}

export const qwikcutCameraSoftwareTypeOptions: {value: QwikcutCameraSoftwareType, display: string}[] = [
	{value: QwikcutCameraSoftwareType.project, display: 'Node.JS Project'},
	{value: QwikcutCameraSoftwareType.model, display: 'Detection Model'},
	{value: QwikcutCameraSoftwareType.visionApp, display: 'Python Stitching/Tracking App'},
	{value: QwikcutCameraSoftwareType.config, display: 'Config File'},
	{value: QwikcutCameraSoftwareType.ngrok, display: 'Ngrok Executable'}
];

export enum CameraCommand {
	SHUTDOWN = 'shutdown',
	REBOOT = 'reboot',
	RESTART_SERVER = 'restart',
	CHECK_FOR_UPDATES = 'check_for_updates',
	UPLOAD_LOGS	= 'upload_logs',
	STOP_CAPTURE = 'stop_capture',
};

export interface RoiConfig {
	topLeft: RoiPoint;
	topCenter: RoiPoint;
	topRight: RoiPoint;
	bottomRight: RoiPoint;
	bottomRightCenter: RoiPoint;
	bottomLeftCenter: RoiPoint;
	bottomLeft: RoiPoint;
}

export interface RoiPoint {
	x: number;
	y: number;
}

export const getDefaultRoiConfig = (): RoiConfig => {
	return {
		topLeft: {x: 0.2, y: 0.2},
		topCenter: {x: 0.5, y: 0.2},
		topRight: {x: 0.8, y: 0.2},
		bottomRight: {x: 0.8, y: 0.8},
		bottomRightCenter: {x: 0.6, y: 0.8},
		bottomLeftCenter: {x: 0.4, y: 0.8},
		bottomLeft: {x: 0.2, y: 0.8}
	};
}

export interface ScoreboardData {
	homeTeam: string;
	homeScore: number;
	awayTeam: string;
	awayScore: number;
	period?: string;
}

export enum TrackingMode {
	tracking = 'tracking',
	full = 'full',
	center = 'center',
	left = 'left',
	right = 'right'
}

export const allTrackingModes: TrackingMode[] = [
	TrackingMode.tracking,
	TrackingMode.full,
	TrackingMode.center,
	TrackingMode.left,
	TrackingMode.right
];

export interface GameVideoFileGroup {
  gameid: string;
  clips: GameVideoFile[];

	game?: Game;
	uploading?: boolean;
}

export interface GameVideoFile {
  path: string;
  clipnumber: number;
  fileSize: number;
}